host.actions.register({
    // #region Vars
    name: '288a.commerce.orderlist.createByCustomer',
    // #endregion
    // #region Entry
    async execute(data, params) {
        // #region Vars
        let tRow = data;
        let tKto = params?.kto;
        // #endregion
        // #region Check
        if (!tKto) {
            return this.Cancel();
        }
        // #endregion
        return await this.sendCore(tKto, {});
    },
    // #endregion
    // #region Core
    methods: {
        async sendCore(customerID, params) {
            // #region Core
            try {
                // #region Run
                let tResult = await this.$host.api.post(`commerce/order-lists/create-from-customer`, {}, { params: { customerID: customerID, ...params } });
                {
                    if (tResult.data.mode === 'showquestion') {
                        let tArgs = {
                            title: tResult.data.title,
                            message: tResult.data.message,
                            successCallback: async () => {
                                await this.sendCore(customerID, { isConfirmed: true });
                            }
                        };
                        return this.Window(await host.notification.showModal2("g-messages-question", tArgs));
                    }
                    else if (tResult.data.cartID) {
                        this.$host.router.openWindow('item:id=' + tResult.data.cartID);
                    }
                }
                //Result
                {
                    return { isSucceeded: true };
                }
                // #endregion
            }
            catch (e) {
                // #region Error
                //Show
                host.notification.showError(e);
                //Error
                return this.Cancel();
                // #endregion
            }
            // #endregion   
        }
    }
    // #endregion
});
export {};
